import { gql } from "@apollo/client";

export const CREATE_GROUP = gql`
  mutation createGroup($input: CreateSkynetUserGroupInput!) {
    rolesAndPermissions {
      createGroup(input: $input) {
        id
        success
      }
    }
  }
`;
